import React from "react";
import { StyledBlackInformationTypography } from "../../../../components/commonComponents/StyledComponents/styled";
import { Box } from "@mui/material";
import ActionButton from "../../../../components/commonComponents/Buttons/ActionButton";
import SectionsList from "./SectionsList";
import NewWorkspaceSection from "./NewWorkspaceSection";
import { Add } from "@mui/icons-material";
import { checkSectionAvailability } from "../../../../api_calls/WorkspaceSections";
import { LISTING_ACTION_TO_TABLE_GAP } from "../../../../components/commonComponents/TabularLists/styles";


const ImpressionsWorkspace = () => {
    const [newSectionPopup, setNewSectionPopup] = React.useState(false);

    React.useEffect(() => {
        checkSectionAvailability()
    }, [])
    return (
        <>
            <Box height={10} />
            <StyledBlackInformationTypography variant="body2" sx={{ marginLeft: 0, fontWeight: "normal" }}>
                Only one impressions section can be created per tenant company and retailer company.
            </StyledBlackInformationTypography>
            <Box height={5} />
            <StyledBlackInformationTypography variant="body2" sx={{ marginLeft: 0 }}>
                Impressions sections are automatically published by the system after the data has been processed for the first time based on the settings defined here.
            </StyledBlackInformationTypography>
            <Box height={2} />
            <StyledBlackInformationTypography variant="body2" sx={{ marginLeft: 0, fontWeight: "normal" }}>
                For campaigns created by retailer users, the impressions section of the respective retailer company is used. For campaigns created by tenant or advertising agency users, the impressions section of the tenant company is used.
            </StyledBlackInformationTypography>
            <Box height={2} />
            <StyledBlackInformationTypography variant="body2" sx={{ marginLeft: 0, fontWeight: "normal" }}>
                Changes made here apply immediately. Impressions sections cannot be archived or removed.
            </StyledBlackInformationTypography>
            <Box height={2} />
            <StyledBlackInformationTypography variant="body2" sx={{ marginLeft: 0 }}>
                Important: To enable automated publishing of impressions sections, an impressions section must be configured for the tenant company and every retailer company.
            </StyledBlackInformationTypography>
            <Box height={10} />

            {/* Removed while implementing Retailer independent access : Removal is part of requirement */}
            {/* {
                showNewSectionButton === true &&
                <ActionButton
                    onClick={(e) => {
                        e.preventDefault();
                        setNewSectionPopup(true);
                    }}
                    label={"New Section"}
                    icon={<Add />}
                />
            } */}


            {/* --------- workspace sections list ----------- */}
            <Box height={LISTING_ACTION_TO_TABLE_GAP} />
            <SectionsList listType={"available"} sectionType={"impression"} />

            {/* --------- new section popup ----------- */}
            {
                newSectionPopup === true && (
                    <NewWorkspaceSection
                        showModal={newSectionPopup}
                        sectionType={"impression"}
                        usedFor="add"
                        closeModal={() => {
                            setNewSectionPopup(false);
                        }}
                    />
                )
            }

        </>
    );
};

export default ImpressionsWorkspace;
